import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bashboard_refresh",
  "use": "icon-bashboard_refresh-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-bashboard_refresh\"><title>bashboard_refresh</title><path d=\"M15.9,8a.57.57,0,1,0-1.13,0h0a6.88,6.88,0,1,1-3.13-5.72L10,3.45,14.62,4.7,14.47.16,12.61,1.54A8,8,0,1,0,15.9,8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol